import debug from 'debug';
import ResultProducts from 'Minetilbud/Shared/Design101/8-organisms/search/render/result-products';
import Data from '../data/data';

const log = debug('ProductPagesSearch:Render:ProductList');

class ProductList extends ResultProducts {
	constructor(element) {
		super(element);
	}

	getDataset() {
		return Data.dataset;
	}

	async getDatasetNew() {
		const data = new Data();
		return data.get();
	}
}

export default ProductList;
